module.exports = __webpack_public_path__ + "img/mist.4615eb8d.jpg";